import { render, staticRenderFns } from "./ScoreCellAdmin.vue?vue&type=template&id=5fce7474&scoped=true&"
import script from "./ScoreCellAdmin.vue?vue&type=script&lang=js&"
export * from "./ScoreCellAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCellAdmin.vue?vue&type=style&index=0&id=5fce7474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fce7474",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
